export const isParsedTag = Symbol('kmarkdown#isParsedTag');
export const nodeCanParseSubContent = Symbol('kmarkdown#nodeCanParseSubContent');
export const syntaxCanParseSubContent = Symbol('kmarkdown#syntaxCanParseSubContent');
